import { useTranslation } from 'react-i18next';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import Panel from 'components/Panel/Panel';
import TitleTableWrapper from 'components/TitleTableWrapper/TitleTableWrapper';
import {
  TASK_HEAD_SECTOR_SPECIFIC_CELLS,
} from 'constants/dataSets';
import { DELETE_MODAL_TITLES } from 'constants/interfaces';
import DeleteModal from 'pages/CompanyAdminPages/ValueChainMap/components/DeleteModal/DeleteModal';

import CreateIndustry from './components/CreateIndustry/CreateIndustry';
import ItemsTable from './components/ItemsTable/ItemsTable';

import type ISectorSpecific from './interfaces/ISectorSpecific';

import styles from './scss/SectorSpecific.module.scss';

function SectorSpecificView({
  isEmptyList, loading, onOpenModal, openModal,
  onAddIndustry, items, hasMore, onLoadMore, onCancel,
  onDeleteItem, isDeleteModalOpen, onDeleteConfirm,
  naceCodesData,
}: ISectorSpecific) {
  const { t } = useTranslation();

  return (
    <Panel className={styles.root}>
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <TitleTableWrapper
            title={t('materialityAssessment.sectorSpecific')}
            hint={t('materialityAssessment.highImpactIndustries')}
            buttonTitle={t('materialityAssessment.addSectorSpecific')}
            onButtonClick={onOpenModal}
            buttonClassName={styles.button}
            showButton
          />
          <div className={styles.contentWrapper}>
            {isEmptyList && !loading ? (
              <EmptyTaskManagement
                title={t('materialityAssessment.sectorSpecificForBusinessDescription')}
                checkIcon
              />
            ) : (
              <div className={styles.tableWrapper}>
                {items && items.length > 0 ? (
                  <ItemsTable
                    items={items}
                    headCells={TASK_HEAD_SECTOR_SPECIFIC_CELLS}
                    onLoadMore={onLoadMore}
                    hasMore={hasMore}
                    isLoadingMore={loading}
                    onDeleteItem={onDeleteItem}
                    naceCodesData={naceCodesData || []}
                    isInfoTable
                  />
                ) : null}
              </div>
            )}
          </div>
        </div>
        <CreateIndustry
          open={openModal}
          onClose={onCancel}
          title={t('materialityAssessment.addSectorSpecific')}
          onAddIndustry={onAddIndustry}
          naceCodesData={naceCodesData}
        />
        <DeleteModal
          open={isDeleteModalOpen}
          onReject={onCancel}
          isLoading={false}
          title={DELETE_MODAL_TITLES.DELETE_SECTOR_SPECIFIC}
          hint={DELETE_MODAL_TITLES.DELETE_SECTOR_SPECIFIC_HINT}
          onConfirm={onDeleteConfirm}
        />
      </div>
    </Panel>
  );
}

export default SectorSpecificView;
